module.exports = __webpack_public_path__ + "img/103ne.a9dd6091.svg";